import {
  Pagination,
  ParkingManagement,
  Type,
} from '@core/interface/parking-managment';
import { createReducer, on } from '@ngrx/store';
import { ParkingManagementActions } from './parking-managment.actions';

export const ParkingManagementFeatureKey = 'ParkingManagement';

export interface ParkingManagementState {
  ParkingManagement: ParkingManagement[];
  isLoading: boolean;
  isDeleted: boolean;
  loadError?: any;
  deleteError?: any;
  addEditError?: any;
  pagination: Pagination;
  types: Type[];
  assigningAsset?: boolean;
  deAssigningAsset?: boolean;
}

export const initialState: ParkingManagementState = {
  ParkingManagement: [],
  isLoading: false,
  isDeleted: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 10,
    total: 100,
  },
  types: [],
  assigningAsset: false,
  deAssigningAsset: false,
};

export const ParkingManagementReducer = createReducer(
  initialState,
  on(ParkingManagementActions.loadParkingManagement, (state) => ({
    ...state,
    ParkingManagement: [],
    isLoading: true,
  })),
  on(
    ParkingManagementActions.loadParkingManagementSuccess,
    (state, { data, pagination }) => ({
      ...state,
      pagination,
      ParkingManagement: data,
      isLoading: false,
      isDeleted: false,
      loadError: null,
    })
  ),
  on(
    ParkingManagementActions.loadParkingManagementFailure,
    (state, { error }) => {
      return { ...state, loadError: error, isLoading: false, isDeleted: false };
    }
  ),
  on(
    ParkingManagementActions.addParkingManagementSuccess,
    (state, { data }) => ({
      ...state,
      ParkingManagement: [...state.ParkingManagement, data],
      isDeleted: false,
      addEditError: null,
    })
  ),
  on(ParkingManagementActions.addParkingManagementFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),
  on(ParkingManagementActions.resetDeleteStatus, (state) => ({
    ...state,
    isDeleted: false,
  })),
  on(ParkingManagementActions.addMarkAsPaidSuccess, (state, { data }) => {
    return {
      ...state,
      ParkingManagement: state.ParkingManagement.map((parking) =>
        data.id == parking.id ? data : parking
      ),
      isDeleted: false,
      addEditError: null,
    };
  }),
  on(ParkingManagementActions.addMarkAsPaidFailure, (state, error) => ({
    ...state,
    isDeleted: false,
    addEditError: error,
  })),

  on(
    ParkingManagementActions.addEditParkingManagement,
    (state, { parking }) => {
      var dd = {
        ...state,
        ParkingManagement: [parking, ...state.ParkingManagement],
        isLoading: false,
      };
      return dd;
    }
  )
);
